import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'
import ChangePassword from '@/components/ChangePassword'
import mainview from '@/components/mainview'
import testEdit from '@/components/testEdit'
import results from '@/components/results'
import managementCenter from '@/components/managementCenter'
import managementTeacher from '@/components/managementTeacher'
import managementDiscipline from '@/components/managementDiscipline'
import recoverPassword from '@/components/recoverPassword'
import managementKnowledge from '@/components/managementKnowledge'
import bareme from '@/components/bareme'
import managementStudentsGroups from '@/components/managementStudentsGroups'
import myAccount from '@/components/myAccount'
import support from '@/components/support'
Vue.use(Router)

var api = ''

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      props: {api: api}
    },
    {
      path: '/changePassword',
      name: 'ChangePassword',
      component: ChangePassword
    },
    {
      path: '/mainview',
      name: 'mainview',
      component: mainview
    },
    {
      path: '/testEdit/:testId',
      name: 'testEdit',
      component: testEdit
    },
    {
      path: '/results/:testId',
      name: 'results',
      component: results
    },
    {
      path: '/managementCenter',
      name: 'managementCenter',
      component: managementCenter
    },
    {
      path: '/managementTeacher',
      name: 'managementTeacher',
      component: managementTeacher
    },
    {
      path: '/managementDiscipline',
      name: 'managementDiscipline',
      component: managementDiscipline
    },
    {
      path: '/recoverPassword',
      name: 'recoverPassword',
      component: recoverPassword
    },
    {
      path: '/managementKnowledge/:testId',
      name: 'managementKnowledge',
      component: managementKnowledge
    },
    {
      path: '/bareme/:testId',
      name: 'bareme',
      component: bareme
    },
    {
      path: '/managementStudentsGroups',
      name: 'managementStudentsGroups',
      component: managementStudentsGroups
    },
    {
      path: '/myAccount',
      name: 'myAccount',
      component: myAccount
    },
    {
      path: '/support',
      name: 'support',
      component: support
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js